// extracted by mini-css-extract-plugin
export default {"price":"y5-z","onSale":"z5-z","msrpLabelPrice":"A5-z","msrpLabel":"B5-z","originalPrice":"C5-z","percentOff":"D5-z"};